import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class VariablesService {
  data:any;
  private route = "./assets/variable/variable-config.json";
  constructor(private http:HttpClient) { }


  getVariables() {
    return this.http.get(this.route).toPromise().then(
      r => { this.data = r;}
    );
  }
}
